import { css } from "styled-components";

export const ModalActionButtonStyles = css`
  padding: 0.75rem;
  font-weight: 500;
`;
